import { FormEvent } from 'react'

export default <T = any>(callback?: (event: Event | FormEvent) => T): ((event: Event | FormEvent) => T | undefined) =>
    (event: Event | FormEvent) => {
        event.preventDefault()
        return callback && callback(event)
    }
